"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DialogLoading = void 0;
const react_1 = __importDefault(require("react"));
const DialogLoading_styles_1 = require("./DialogLoading.styles");
const Overlay_1 = require("../../../Overlay");
exports.DialogLoading = react_1.default.memo(function DialogLoading({ loading }) {
    return loading ? (react_1.default.createElement(DialogLoading_styles_1.StyledDialogLoadingBlockingWrapper, { view: Overlay_1.OVERLAY_VIEW.soft, contentMod: Overlay_1.OVERLAY_CONTENT_MOD.center },
        react_1.default.createElement(DialogLoading_styles_1.StyledDialogLoadingProgressBar, null))) : (react_1.default.createElement(DialogLoading_styles_1.StyledDialogLoadingNonBlockingWrapper, null,
        react_1.default.createElement(DialogLoading_styles_1.StyledDialogLoadingProgressBar, null)));
});
//# sourceMappingURL=DialogLoading.js.map